import type { Step } from "react-joyride";

export const monthlyReportFormCreateTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ສ້າງລາຍງານປະຈໍາເດືອນໃໝ່. ເລືອກເດືອນ ປີ ພະແນກ ແລະ ອັບໂຫຼດເອກະສານ ຫຼື ໃສ່ລິ້ງ URL.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="monthly-report-form-create-back"]',
    content:
      "ກັບຄືນໄປຫນ້າລາຍການລາຍງານປະຈໍາເດືອນ. ກົດປຸ່ມ ? ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="monthly-report-form-create-form"]',
    content:
      "ເລືອກເດືອນ, ປີ, ພະແນກ, ຊື່ ແລະ ອັບໂຫຼດໄຟລ໌ ຫຼື ໃສ່ລິ້ງ. ກົດບັນທຶກເພື່ອສ້າງ.",
    placement: "top",
  },
];
